/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Address_ComplementInputs */

const en_clients_field_address_complement = /** @type {(inputs: Clients_Field_Address_ComplementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complement`)
};

const pt_br2_clients_field_address_complement = /** @type {(inputs: Clients_Field_Address_ComplementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complemento`)
};

/**
* | output |
* | --- |
* | "Complement" |
*
* @param {Clients_Field_Address_ComplementInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_address_complement = /** @type {((inputs?: Clients_Field_Address_ComplementInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Address_ComplementInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_address_complement(inputs)
	return pt_br2_clients_field_address_complement(inputs)
});